// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-accordion-module{margin:20px auto;font-size:14px;line-height:1.5}@media (min-width:768px){.v-accordion-module{margin-top:30px;margin-bottom:30px;font-size:16px}}.v-accordion-module__label .h-expand-button__activator__label{font-size:16px}@media (min-width:768px){.v-accordion-module__label .h-expand-button__activator__label{font-size:18px}}.v-accordion-module__text{padding:10px 20px}", ""]);
// Exports
module.exports = exports;
